import {
  SHOP_SEARCH, SHOP_SEARCH_SUCCESS, SHOP_SEARCH_FAILURE, SHOP_CLEAR, SHOP_ALL_SEARCH, SHOP_ALL_SEARCH_FAILURE, SHOP_ALL_SEARCH_SUCCESS,
  SHOP_GET, SHOP_GET_SUCCESS, SHOP_GET_FAILURE,
  SHOP_SELECT_GET, SHOP_SELECT_GET_SUCCESS, SHOP_SELECT_GET_FAILURE,
  SHOP_LIST_SEARCH, SHOP_LIST_SEARCH_SUCCESS, SHOP_LIST_SEARCH_FAILURE,
  NOTIFICATION_ADD, SHOP_UPDATE, SHOP_UPDATE_SUCCESS, SHOP_UPDATE_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    shops: [],
    shopsNextPage: 1,
    shopsCurrentPage: null,
    shopsNotify: null
  },
  getters: {
    shops: state => {
      return state.shops
    },
    shopsNextPage: state => {
      return state.shopsNextPage
    },
    shopsNotify: state => {
      return state.shopsNotify
    }
  },
  actions: {
    [SHOP_SEARCH] ({dispatch, state, commit}, params = null) {
      var data = {}
      var callback = () => {}
      var allShopName = null
      if (params) {
        data = params.data
        if (params.callback) {
          callback = params.callback
        }
        if (params.callback) {
          callback = params.callback
        }
        if (params.allShopName) {
          allShopName = params.allShopName
        }
      }
      dispatch('apiGet', {url: '/shops', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHOP_SEARCH_SUCCESS, {data: res.data, callback: callback, allShopName: allShopName})
          }
        }
      })
    },
    [SHOP_ALL_SEARCH] ({dispatch, state, commit}, params = null) {
      var data = {}
      var callback = () => {}
      if (params) {
        data = params.data
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: '/shops/shop_all', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_ALL_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHOP_ALL_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
    },
    [SHOP_LIST_SEARCH] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/shops'
      var loadparams = true
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_LIST_SEARCH_FAILURE, res.data)
          } else {
            commit(SHOP_LIST_SEARCH_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHOP_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(SHOP_CLEAR)
      }, sleep)
    },
    [SHOP_GET] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var shopId = null
        if (params) {
          shopId = params.data.shop_id
        }
        dispatch('apiGet', {url: '/shops/' + shopId})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SHOP_GET_FAILURE, res.data)
              dispatch(NOTIFICATION_ADD, {data: {danger: true, message_direct: res.data.error}})
              reject()
            } else {
              commit(SHOP_GET_SUCCESS, res.data)
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [SHOP_SELECT_GET] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var shopId = null
        if (params) {
          var cnt = 0
          for (var i in params.data.shop_list.data) {
            if (cnt === 0) {
              shopId = 'shop_list[]=' + params.data.shop_list.data[i]
            } else {
              shopId = shopId + '&shop_list[]=' + params.data.shop_list.data[i]
            }
            cnt += 1
          }
        }
        dispatch('apiGet', {url: '/shops/shop_search_get?' + shopId})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SHOP_SELECT_GET_FAILURE, res.data)
              dispatch(NOTIFICATION_ADD, {data: {danger: true, message_direct: res.data.error}})
              reject()
            } else {
              commit(SHOP_SELECT_GET_SUCCESS, res.data)
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [SHOP_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      var url = ''
      var callback = () => {}
      console.log(JSON.stringify(params))
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        if (params.data.shop_id) {
          url = '/shops/' + params.data.shop_id
        }
        data = params.data.shop
      }
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_UPDATE_FAILURE, { data: res.data, callback: callback })
          } else {
            commit(SHOP_UPDATE_SUCCESS, { data: res.data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_SEARCH_SUCCESS] (state, params) {
      console.log('SHOP_SEARCH_SUCCESS')
      var data = params.data
      // state.shops = [{id: null, attributes: {'shop-name': '全店舗'}}].concat(data.data)
      if (params.allShopName) {
        state.shops = [{id: null, attributes: {'shop-name': params.allShopName}}].concat(data.data)
      } else {
        state.shops = data.data
      }
      if (data.meta && data.meta['next-page']) {
        state.shopsNextPage = data.meta['next-page']
      }
      if (params.callback) {
        params.callback()
      }
    },
    [SHOP_SEARCH_FAILURE] (state, data) {
      console.log('SHOP_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [SHOP_ALL_SEARCH_SUCCESS] (state, params) {
      console.log('SHOP_ALL_SEARCH_SUCCESS')
      var data = params.data
      state.shops = [{id: null, attributes: {'shop-name': '全店舗'}}].concat(data.data)
      if (params.callback) {
        params.callback()
      }
    },
    [SHOP_ALL_SEARCH_FAILURE] (state, data) {
      console.log('SHOP_ALL_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [SHOP_LIST_SEARCH_FAILURE] (state, data) {
      console.log('SHOP_LIST_SEARCH_FAILURE')
    },
    [SHOP_LIST_SEARCH_SUCCESS] (state, data) {
      console.log('SHOP_LIST_SEARCH_SUCCESS')
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.shops = state.shops.concat(data.data)
        state.shopsCurrentPage = data.meta['current-page']
      } else {
        state.shops = data.data
        state.shopsCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.shopsNextPage = data.links['next']
      } else {
        state.shopsNextPage = null
      }
    },
    [SHOP_CLEAR] (state) {
      state.shops = []
    },
    [SHOP_GET_FAILURE] (state, data) {
      console.log('SHOP_GET_FAILURE')
    },
    [SHOP_GET_SUCCESS] (state, data) {
      console.log('SHOP_GET_SUCCESS')
    },
    [SHOP_SELECT_GET_FAILURE] (state, data) {
      console.log('SHOP_SELECT_GET_FAILURE')
    },
    [SHOP_SELECT_GET_SUCCESS] (state, data) {
      console.log('SHOP_SELECT_GET_SUCCESS')
    },
    [SHOP_UPDATE_FAILURE] (state, data) {
      console.log('SHOP_UPDATE_FAILURE')
      // 通知
      state.shopsNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.shopsNotify = null
      }, constant.notifyShowTime.normal)
    },
    [SHOP_UPDATE_SUCCESS] (state, data) {
      console.log('SHOP_UPDATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js